import { create } from '@thoughtspot/logger';
import { processLegacyDataToSDKQueryData } from '../../../utils/chart-model-adaptor.util';
import { mapSDKQueryToDataQueryInput } from '../../../utils/data-query.util';
import { validateGetDataForQueryEventPayloadObject } from './util';
const logger = create('ts-to-chart > event-callbacks > get-data-query');
const validateGetDataForQueryEventPayload = (eventData) => {
    try {
        validateGetDataForQueryEventPayloadObject(eventData.payload);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
const getGetDataForQueryEventProcessor = (props) => {
    return {
        validateEventPayload: (eventData) => {
            return validateGetDataForQueryEventPayload(eventData);
        },
        executeEvent: async (eventData) => {
            const queries = eventData?.payload?.queries;
            const dataQueryInput = mapSDKQueryToDataQueryInput(queries);
            const res = await props.getAnswerDataByQuery(dataQueryInput);
            const parsedData = processLegacyDataToSDKQueryData(res);
            return Promise.resolve(parsedData);
        },
    };
};
export { getGetDataForQueryEventProcessor };
//# sourceMappingURL=index.js.map